<template>
    <div>
        <select ref="selectElement" class="form-control bootstrap-select" :name="name"></select>
    </div>
</template>

<script setup lang="ts">
    import type { IDataSource } from "@/data/dao/service/BaseServiceDao";
    import { SelectBootstrap } from "@/operator/elements/SelectBootstrap";
    import { trans } from "@/operator/localization/Trans";
    import { onMounted, ref } from "vue";

    const selectedValues = defineModel<string[] | undefined>({
        required: true,
    });

    const props = defineProps<{
        dataSource: IDataSource<any>;
        name?: string;
        keyProp?: string;
        textProp?: string;
    }>();

    const emit = defineEmits<{
        onChange: [values: string[]];
    }>();

    const selectElement = ref<HTMLElement | null>(null);
    let select: SelectBootstrap<any>;

    onMounted(() => {
        select = SelectBootstrap.createFromSelectWithOptions<any>({
            $select: $(selectElement.value!),
            dataSource: props.dataSource,
            formatter: (entity) => {
                return entity[props.textProp ?? "name"];
            },
            lazyInit: true,
            keyProp: props.keyProp ?? "id",
            showAllText: trans.general.all,
            multiSelect: true,
        });

        fetchAndInit();
    });

    function fetchAndInit() {
        select.fetchData(() => {
            select.onChange = () => {
                const newValues = select.getValues();
                selectedValues.value = newValues;
                emit("onChange", newValues);
            };

            if (selectedValues.value) {
                const allowedValues = select.getOptions();
                const allowedSelectedValues = selectedValues.value.filter((x) => allowedValues.includes(x));
                select.setValues(allowedSelectedValues);
            }
        });
    }

    async function refreshDataSource() {
        await select.fetchData();
    }

    function setError(hasError: boolean) {
        select.setError(hasError);
    }

    defineExpose({
        refreshDataSource,
        setError,
    });
</script>
